import { render, staticRenderFns } from "./joinCompany.vue?vue&type=template&id=3cc05c19"
import script from "./joinCompany.vue?vue&type=script&lang=js"
export * from "./joinCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports